import { render, staticRenderFns } from "./ShrinkCommentItem.vue?vue&type=template&id=b210533c&scoped=true&"
import script from "./ShrinkCommentItem.vue?vue&type=script&lang=js&"
export * from "./ShrinkCommentItem.vue?vue&type=script&lang=js&"
import style0 from "./ShrinkCommentItem.vue?vue&type=style&index=0&id=b210533c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210533c",
  null
  
)

export default component.exports